import { render } from "./video-author-intro.vue?vue&type=template&id=7ffcf61a&scoped=true"
import script from "./video-author-intro.vue?vue&type=script&lang=ts"
export * from "./video-author-intro.vue?vue&type=script&lang=ts"

import "./video-author-intro.vue?vue&type=style&index=0&id=7ffcf61a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7ffcf61a"

export default script